"use strict";

require("core-js/modules/esnext.string.match-all.js");
var r = require("tslib"),
  e = function e(_e, t) {
    if (r.__spreadArray([], r.__read(t.matchAll(/#/g)), !1).length !== _e.length) return _e;
    var n = 0;
    return t.replace(/#/g, function () {
      return _e[(n += 1) - 1];
    });
  };
exports.cellphonePattern = function (r) {
  return e(r, "(##) #####-####");
}, exports.cpfPattern = function (r) {
  return e(r, "###.###.###-##");
}, exports.currencyMask = function (r, e) {
  if (!r) return "";
  var t = Number.isNaN(+r) ? r : Number(r).toFixed(2),
    n = parseFloat(t.replace(/[^\d]/g, "").replace(/(\d\d?)$/, ".$1")).toLocaleString("pt-BR", {
      style: "currency",
      currency: e || "BRL"
    }).replace("", "");
  return 0 === parseFloat(n.replace(",", ".")) ? "" : n.trim();
}, exports.datePattern = function (r) {
  return e(r.replace(/-/g, ""), "##/##/####");
}, exports.formatToPattern = e;